import { render, staticRenderFns } from "./DefaultPassThroughBid.vue?vue&type=template&id=6b01d5e6"
import script from "./DefaultPassThroughBid.vue?vue&type=script&lang=js"
export * from "./DefaultPassThroughBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports